<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Expense Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>Expense Name</label>
                <input type="text" class="form-control" v-model="expense.name" id="name" aria-describedby="action">
            </div>
            <div class="form-group col-3">
                <label for="category">Category</label>
                <app-dropdown :id="'category'" :keyName="'category'" :model="expense.category" :lists="categoryList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Remarks</label>
                <textarea class="form-control" id="desc-textarea" v-model="expense.remarks" rows="2"></textarea>
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { Expense } from '../../models/expense'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            expense: {
                ...Expense
            },
            categoryList: [],
        }
    },
    async created() {
        const categoryApi = api('expense/category')
        this.categoryList = await categoryApi.get()

        if(this.$route.query.id !== undefined) {
            const expenseApi = api('expense/detail')

            const expenseResult = await expenseApi.getWithParams(this.$route.query.id)
            this.expense = expenseResult
        }
    },
    methods: {
        async save() {
            const expenseApi = api('expense')
            if(this.$route.query.id !== undefined) {
                await expenseApi.update(this.expense, this.$route.query.id)
            } else {
                await expenseApi.create(this.expense)
            }
            this.$router.push({ name: 'expense' })
        },
        cancel() {
            this.$router.push({ name: 'expense' })
        },
        finishLookup(data) {
            const currentExpense = this.expense
            this.expense = {
                ...currentExpense,
                ...data
            }
        },
        selectChange(data) {
            const currentExpense = this.expense
            this.expense = {
                ...currentExpense,
                ...data
            }
        },
    }
}
</script>